// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NetworkServiceDetails } from './NetworkServiceDetails';
import {
  NetworkServiceDetailsFromJSON,
  NetworkServiceDetailsFromJSONTyped,
  NetworkServiceDetailsToJSON,
  NetworkServiceDetailsToJSONTyped,
} from './NetworkServiceDetails';

/**
 *
 * @export
 * @interface OrchestraState
 */
export interface OrchestraState {
  /**
   *
   * @type {NetworkServiceDetails}
   * @memberof OrchestraState
   */
  exposedService?: NetworkServiceDetails;
}

/**
 * Check if a given object implements the OrchestraState interface.
 */
export function instanceOfOrchestraState(
  value: object,
): value is OrchestraState {
  return true;
}

export function OrchestraStateFromJSON(json: any): OrchestraState {
  return OrchestraStateFromJSONTyped(json, false);
}

export function OrchestraStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OrchestraState {
  if (json == null) {
    return json;
  }
  return {
    exposedService:
      json['exposed_service'] == null
        ? undefined
        : NetworkServiceDetailsFromJSON(json['exposed_service']),
  };
}

export function OrchestraStateToJSON(json: any): OrchestraState {
  return OrchestraStateToJSONTyped(json, false);
}

export function OrchestraStateToJSONTyped(
  value?: OrchestraState | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    exposed_service: NetworkServiceDetailsToJSON(value['exposedService']),
  };
}
